import { useMemo } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useCompanyDateFormat } from "../../../../../../utils/hooks/company";
import { renderUserName } from "../../../../../../utils/helpers/user";

const columnHelper = createColumnHelper();

export const useColumns = ({ openDeleteModal, openSummaryModal }) => {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();

    return useMemo(() => [
        columnHelper.accessor("createdAt", {
            header: t("date"),
            cell: (info) => {
                const value = info.getValue();
                return value && moment(value).format(dateFormat);
            }
        }),
        columnHelper.accessor("createdBy", {
            header: t("user"),
            cell: (info) => {
                const value = info.getValue();
                return value && renderUserName(value);
            }
        }),
        columnHelper.accessor("createdTimesheets", {
            header: t("created-timesheets"),
            cell: ({ row: { original } }) => {
                const createdItems = Object.values(original.data.createdItems || {}).flat();
                return (
                    <div className="d-flex justify-content-center mr-5">
                        <span
                            className="rounded px-3 py-2 text-white"
                            style={{ background: "#755dc1e0" }}
                        >
                            {createdItems?.length || 0}
                        </span>
                    </div>
                );
            }
        }),
        columnHelper.display({
            header: t("actions"),
            cell: ({ row: { original } }) => {
                const notReverted = !original?.revertedAt;
                return (
                    <div className="d-flex align-items-center gap-x-3">
                        <FontAwesomeIcon
                            className="text-primary cursor-pointer"
                            icon={faEye}
                            onClick={() => openSummaryModal(original)}
                        />

                        {notReverted ? (
                            <FontAwesomeIcon
                                className="text-danger cursor-pointer"
                                icon={faTrash}
                                onClick={() => openDeleteModal(original?.id)}
                            />
                        ) : (
                            <span
                                className="rounded px-3 py-2"
                                style={{
                                    color: "red",
                                    border: "1px solid red",
                                    background: "#ff000014"
                                }}
                            >
                                {t("removed")}
                            </span>
                        )}
                    </div>
                );
            }
        })
    ], [dateFormat, openDeleteModal, openSummaryModal, t]);
}
